export * from './errors';
export * from './common';
export * from './me';
export * from './attempts';
export * from './progress';
export * from './recap';
export * from './auth';

import { z } from 'zod';

export const HealthResponseSchema = z.object({ ok: z.boolean(), db: z.enum(['up', 'down']) });
export type HealthResponse = z.infer<typeof HealthResponseSchema>;

/** API base path. */
export const API_PREFIX = '/api/v1';
